<template>
  <div>
    <!-- Row displaying logged-in user's info -->
    <v-list-item
      class="mt-2 mb-2"
    >
      <!-- His avatar -->
      <template v-slot:prepend>
      <v-avatar color="primary">
        <v-icon color="white">
          mdi-account
        </v-icon>
      </v-avatar>
    </template>

      <!-- His details -->
        <div style="word-wrap: break-word; overflow-wrap: break-word;">
          {{ userStore.fullName }}
        </div>
      <v-list-subheader>
        <div>{{ userStore.userName }}</div>
        <div v-if="userStore.role === 'superadmin'">{{ userStore.role }}</div>
      </v-list-subheader>
        <!-- Logout button -->
        <template v-slot:append>
          <v-btn
            id="logoutButton"
            icon="mdi-logout"
            ripple
            @click="logout"
          >
            <v-icon
              color="grey lighten-1"
            >
              {{ 'mdi-logout' }}
            </v-icon>
          </v-btn>
      </template>
    </v-list-item>
    <!-- Divider for menu entries -->
    <v-divider />
    <!-- Menu -->
    <v-list>
      <!-- Dynamically rendered admin-visible menu entries -->
      <v-list-item
        v-for="adminMenuItem in adminMenuEntries"
        :id="adminMenuItem.id"
        :key="adminMenuItem.label"
        link
        nuxt
        exact
        :disabled="adminMenuItem.disabled"
        :to="adminMenuItem.to"
      >
        <!-- Menu entry icon -->
        <template v-slot:prepend>
          <v-icon>{{ adminMenuItem.icon }}</v-icon>
        </template>
        <!-- Menu entry label -->
          <v-list-item-title>{{ adminMenuItem.label }}</v-list-item-title>
      </v-list-item>

      <!-- Superadmin's submenu -->
      <v-list
        v-if="userStore.role === 'superadmin'"
        value="true"
        no-action
      >
        <!-- Title of the submenu -->
          <v-list-item
          @click="showSuperAdminMenu = !showSuperAdminMenu">
            <v-list-item-title>
              Správa
            </v-list-item-title>


            <template v-slot:prepend>
              <v-icon>
                {{ 'mdi-cog' }}
              </v-icon>
            </template>
          </v-list-item>

        <!-- Dynamically rendered superadmin's menu entries -->
        <template v-if="showSuperAdminMenu">
        <v-list-item
          v-for="superadminMenuEntry in superadminMenuEntries"
          :id="superadminMenuEntry.id"
          :key="superadminMenuEntry.label"
          :disabled="superadminMenuEntry.disabled"
          link
          nuxt
          exact
          :to="superadminMenuEntry.to"
        >


            <v-list-item-title>{{ superadminMenuEntry.label }}</v-list-item-title>
   
          <template v-slot:append>
            <v-icon>{{ superadminMenuEntry.icon }}</v-icon>
          </template>
        </v-list-item>
      </template>
      </v-list>
    </v-list>
  </div>
</template>

<script>
  /**
   * @description Sidenav component with user's info and menu
   * @module components/Sidenav
   * @vue-data {boolean} showSuperAdminMenu - whether superadmin's submenu is shown
   * @vue-data {array} adminMenuEntries - entries displayed to all admins
   * @vue-data {array} superadminMenuEntries - entries displayed only to superadmins
   * @vue-data {Object} userStore - user's store
   * @vue-methods logout - method for signing out
   */
  import {useUserStore} from "../store/user"

  export default {
    data() {
      return {
        showSuperAdminMenu: false,
        // Entries displayed to everyone
        adminMenuEntries: [
          {
            label: 'Přehled',
            icon: 'mdi-speedometer',
            //to: this.localePath('index'),
            to: this.localePath('index'),
            id: 'navDashboard',
            disabled: false
          },
          {
            label: 'Ankety',
            icon: 'mdi-text-box-multiple',
            to: this.localePath('surveys'),
            id: 'navSurveys',
            disabled: false
          },
          {
            label: 'Otázky',
            icon: 'mdi-help-circle',
            to: this.localePath('questions'),
            id: 'navQuestions',
            disabled: false
          },
          {
            label: 'Seznamy otázek',
            icon: 'mdi-format-list-bulleted',
            to: this.localePath('sets'),
            id: 'navSets',
            disabled: false
          },
          // { // TODO
          //   label: 'Komentáře',
          //   icon: 'comment',
          //   to: this.localePath('comments'),
          //   id: 'navComments',
          //   disabled: false
          // }
        ],
        // Entries displayed only to superadmin role
        superadminMenuEntries: [
          // {
          //   label: 'Záznamy (todo)',
          //   icon: 'history',
          //   to: this.localePath('logs'),
          //   id: 'navLogs'
          // },
          // {
          //   label: 'Ovládací panel',
          //   icon: 'mdi-tools',
          //   to: this.localePath('controlPanel'),
          //   id: 'navControlPanel'
          // },
          {
            label: 'Uživatelé',
            icon: 'mdi-account-group',
            to: this.localePath('users'),
            id: 'navUsers',
            disabled: false
          },
          {
            label: 'Aktuality',
            icon: 'mdi-newspaper-variant-multiple',
            to: this.localePath('news'),
            id: 'navNews',
            disabled: false
          },
          {
            label: 'Nástěnka',
            icon: 'mdi-clipboard-text',
            to: this.localePath('noticeBoard'),
            id: 'navNoticeBoard',
            disabled: false
          },
          // {
          //   label: 'Zpětná vazba',
          //   icon: 'mdi-email-alert',
          //   to: this.localePath('feedback'),
          //   id: 'navFeedback'
          // }
        ],
        userStore: useUserStore()

      }
    },

    methods: {

      logout() {
        
        useUserStore().signOut()
      }
    }
  }
</script>
